// extracted by mini-css-extract-plugin
export default {"issueTypeTokenContainer":"IssueTypeToken-module__issueTypeTokenContainer--ZxBhZ","tokenText":"IssueTypeToken-module__tokenText--fyjvE","token":"IssueTypeToken-module__token--iQHKj"};